import type { UserErrorKeys } from './types.ts';

export const UserErrors: Record<UserErrorKeys, string> = {
  email: 'User with this email already exists.',
};
